export default __webpack_public_path__ + "static/media/locationImg.1b30aa58.png";